<div class="ticket-summary-list"
     fxLayout="column"
     fxLayoutGap="20px">

    <ng-container *ngFor="let eventTicketItems of eventShoppingItemsMap |keyvalue; last as isLast ">

        <btx-ticket-summary-item-new [eventTickets]="eventTicketItems.value"
                                 [isLast]="isLast"
                                 [digitalTicketLink]="shoppingCart.digitalTicketLink"
                                 [invoiceLink]="shoppingCart.eticketLink"
                                 [tffEvent]="shoppingCart.tffEvent"
                                 [liveEventTokens]="shoppingCart.liveEventTokens"
                                 [liveEventDistributionLink]="shoppingCart.liveEventDistributionLink"
                                 [isHomePrint]="isHomePrint()"
                                 [eventUpsells]="eventShoppingUpsellMap.get(eventTicketItems.key)">
        </btx-ticket-summary-item-new>
    </ng-container>

</div>
